import React, { useContext } from "react"
import { store } from '../../stores/admin_templates'
import { Modal, ModalHeader, ModalBody, Button } from "reactstrap"
import { X } from "react-feather"

const DeleteTemplateModal = (props) => {
  const { deleteOpen, human_name: humanName, deleting, templateToDelete, actions, dispatch } = useContext(store)

  const toggle = () => {
    dispatch({ type: actions.TOGGLE_DELETE_MODAL })
  }

  const closeButton = (
    <Button color="link" onClick={toggle} className="p-0 text-muted">
      <X />
    </Button>
  )

  const handleDeleteEvent = () => {
    dispatch({ type: actions.DELETE_TEMPLATE })
  }

  return (
    <Modal size="md" isOpen={deleteOpen} toggle={toggle}>
      <ModalHeader
        close={closeButton}
        toggle={toggle}
        className="modal-header-segmented d-flex align-items-center"
        tag="div"
      >
        <h2 className="fst-normal fs-5 m-0">
          Are you sure you want to delete this {humanName}?
        </h2>
      </ModalHeader>
      <ModalBody>
        <p><code>{templateToDelete?.attributes.template_filename}</code></p>
        <p className="fs-6">
          This action cannot be undone.
        </p>
        <div className="d-flex gap-3">
          <Button color="danger" onClick={() => handleDeleteEvent()} disabled={deleting}>
            Delete {humanName}
          </Button>
          <Button color="outline-secondary" onClick={(e) => toggle()} disabled={deleting}>
            Cancel
          </Button>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default DeleteTemplateModal
